module.exports = __webpack_public_path__ + "img/slash-circle-01.76223c9c.svg";